var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentFailed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2169 22.9986C45.2169 35.2716 35.2677 45.2208 22.9947 45.2208C10.7217 45.2208 0.772461 35.2716 0.772461 22.9986C0.772461 10.7256 10.7217 0.776367 22.9947 0.776367C35.2677 0.776367 45.2169 10.7256 45.2169 22.9986ZM16.2605 16.2645C16.9114 15.6136 17.9667 15.6136 18.6175 16.2645L22.9946 20.6415L27.3716 16.2645C28.0225 15.6137 29.0778 15.6137 29.7287 16.2645C30.3795 16.9154 30.3795 17.9707 29.7287 18.6215L25.3516 22.9986L29.7286 27.3755C30.3795 28.0264 30.3795 29.0817 29.7286 29.7326C29.0777 30.3834 28.0225 30.3834 27.3716 29.7326L22.9946 25.3556L18.6176 29.7326C17.9667 30.3835 16.9114 30.3835 16.2606 29.7326C15.6097 29.0817 15.6097 28.0265 16.2606 27.3756L20.6376 22.9986L16.2605 18.6215C15.6096 17.9706 15.6096 16.9154 16.2605 16.2645Z",
    fill: "#E31C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentFailed);
export default __webpack_public_path__ + "static/media/paymentFailed.d7ca5030b4c3699166a7e47d854937d2.svg";
export { ForwardRef as ReactComponent };